import { render } from "./confirmation-modal.vue?vue&type=template&id=1934d25b&scoped=true"
import script from "./confirmation-modal.vue?vue&type=script&lang=js"
export * from "./confirmation-modal.vue?vue&type=script&lang=js"

import "./confirmation-modal.vue?vue&type=style&index=0&id=1934d25b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1934d25b"]])

export default __exports__